<template>
  <div :class="{'open': isActive}" class="dropdown">
    <div v-if="isActive" class="dropdown-mask" @click="isActive=false" />
    <a class="dropdown-option" @click="isActive=!isActive">
      <slot name="option" />
    </a>
    <div :class="{'active': isActive}" class="dropdown-menu">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    dropdownActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isActive: false
    }
  },
  watch: {
    isActive(newValue) {
      if (newValue) {
        this.$emit('update')
      }
    },
    dropdownActive(newValue) {
      this.isActive = newValue
    }
  },
  methods: {
    dropdownClose() {
      //
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.dropdown{
  position: absolute;
  top: 16px;
  right: 24px;
  right: 6%;
  z-index: 1;
  user-select: none;
  &.open{
    z-index: 2;
  }
}
.dropdown-mask{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: transparent;
  opacity: 0;
  z-index: 5;
}
.dropdown-option{
  position: relative;
  z-index: 10;
  cursor: pointer;
  i{
    color: #fff;
  }
}
.dropdown-menu{
  position: absolute;
  top: 40px;
  left: -13px;
  z-index: 10;
  display: none;
  opacity: 0;
  transition: .4s all cubic-bezier(0.175, 0.885, 0.32, 1.275);
  ul{
    width: 160px;
    padding: 0;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    li{
      display: block;
      width: 100%;
      text-align: left;
      font-size: 16px;
      font-weight: bold;
      line-height: 54px;
      color: $grey-9b;
      padding: 0 16px;
      background: #fff;
      border-top: solid 1px #f7f7f7;
      transition: .2s all cubic-bezier(0.165, 0.84, 0.44, 1);
      cursor: pointer;
      i{
        font-size: 20px;
        color: $grey-50;
        margin-right: 16px;
        vertical-align: middle;
      }
      &:first-child{
        border-top: 0;
      }
      &:hover{
        background: $grey-f3;
      }
    }
  }
  &:before{
    content: "";
    position: absolute;
    display: block;
    top: -7px;
    left: 15px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 7px 9px;
    border-top-width: 0;
    border-color: transparent;
    border-bottom-color: white;
    z-index: 1;
  }
  &.active{
    display: block;
    opacity: 1;
  }
}
</style>
